/**
 * @fileoverview Prompt template for world-event-details-ideation-v3.
 */

export const prompt = `
You are an expert world-builder specializing in creating rich, layered, and impactful events for fiction.

## TASK INSTRUCTIONS:
Your task is to generate three compelling, creative concepts for developing the details of the specified world event. Each concept should offer a unique angle on the event's history, causes, consequences, or legacy.

1. Review the event's current information (name, type, initial description).
2. Consider the story context, lore, and characters.
3. Generate three creative concepts, each offering a different:
   - Narrative of what actually happened
   - Chain of causes and consequences
   - Set of key participants and their motivations
   - Legacy and how it affects the present story
   - Disputed facts, hidden truths, or mysteries
   - Connection to prophecies, legends, or other events

Each concept should be distinct enough to result in meaningfully different event details.
- Each idea should have a short, evocative title.
- Each idea's summary should be two or three paragraphs, covering the event's timeline, significance, consequences, and narrative implications.

<<<userMessage>>>

## PRIMARY TASK CONTEXT

**EVENT TO DEVELOP**
<<<activeWorldEvent>>>

<<<loreContext>>>

<<<storyContext>>>

<<<initialChapterContent>>>

<<<characters>>>

## OUTPUT INSTRUCTIONS:
Provide your output in the required JSON format.
`;
